import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Button, Select, MenuItem, Checkbox, ListItemText, FormControl } from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { isCompany } from '../../Config/isCompany';
import NotFoundPage from '../../Pages/NotFoundPage';
import JoditEditor from "jodit-react";
import "../shared/modern-ui.css";

const CreatePost = () => {
  const [dataValues, setDataValues] = useState(false);
  const [company, setCompany] = useState({});
  
  const [companies, setCompanies] = useState([]);
  useEffect(() => {
    const fetchCompanyDetails = async () => {
      try {
        const response = await axios.get("https://kariyer.biyomed.net/api/companies/getOneDetails", {
          withCredentials: true,
        });
        setDataValues(response.data ? true : false);

      } catch (err) {
        console.error("Veri çekme hatası:", err);
      }
    };
    fetchCompanyDetails();
  }, []);
  const [selectedCompany, setselectedCompany] = useState('');
  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const response = await axios.get(
          "https://kariyer.biyomed.net/api/companies/getOne",
          { withCredentials: true }
        );
        setCompany(response.data.company);
        if (response.data.company.user_type !== "Dernek") {
          setFormData((prevState) => ({
            ...prevState,
            company_name: response.data.company.company_name,
          }));
        }
        else {
          const res = await axios.get('https://kariyer.biyomed.net/api/companies/getAll');
          setCompanies(res.data.companies);
        }
      } catch (error) {
        console.error("Error fetching company details:", error);
      }
    };
    fetchCompany()
  }, []); // `post` değiştiğinde yeniden çağırır
  // State değişkenleri
  const [formData, setFormData] = useState({
    company_name: '',
    company_about: '',
    job_type: '',
    work_style: '',
    position_category: '',
    position_name: '',
    city: '',
    position_tags: '',
    job_description: '',
    required_qualifications: '',
    required_experience: '',
    other_comments: '',
    job_link: '',
    job_status: '',
    document_upload: null,
  });
  const cities = [
    "Genel","Adana", "Adıyaman", "Afyonkarahisar", "Ağrı", "Aksaray", "Amasya", "Ankara", "Antalya",
    "Ardahan", "Artvin", "Aydın", "Balıkesir", "Bartın", "Batman", "Bayburt", "Bilecik", "Bingöl",
    "Bitlis", "Bolu", "Burdur", "Bursa", "Çanakkale", "Çankırı", "Çorum", "Denizli", "Diyarbakır",
    "Düzce", "Edirne", "Elazığ", "Erzincan", "Erzurum", "Eskişehir", "Gaziantep", "Giresun",
    "Gümüşhane", "Hakkari", "Hatay", "Iğdır", "Isparta", "İstanbul", "İzmir", "Kahramanmaraş",
    "Karabük", "Karaman", "Kars", "Kastamonu", "Kayseri", "Kırıkkale", "Kırklareli", "Kırşehir",
    "Kilis", "Kocaeli", "Konya", "Kütahya", "Malatya", "Manisa", "Mardin", "Mersin", "Muğla",
    "Muş", "Nevşehir", "Niğde", "Ordu", "Osmaniye", "Rize", "Sakarya", "Samsun", "Siirt",
    "Sinop", "Sivas", "Şanlıurfa", "Şırnak", "Tekirdağ", "Tokat", "Trabzon", "Tunceli",
    "Uşak", "Van", "Yalova", "Yozgat", "Zonguldak", "Yurt Dışı"
  ];
  const positionCategories = [
    "Araştırma Geliştirme (AR-GE)",
    "Geri Ödeme/Pazara Erişim",
    "Klinik Destek/Aplikasyon",
    "Kalite/Belgelendirme/Mevzuat",
    "Lojistik ve Tedarik Zinciri",
    "Pazarlama/Ürün Yönetimi",
    "Satış",
    "Teknik Servis",
    "Teknoloji Yönetimi",
    "Test/Kalibrasyon/Muayene",
    "Üretim",
    "Diğer"
  ];



  // Input değişikliklerini işleyen fonksiyon
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleCityChange = (e) => {
    const selectedCities = e.target.value;
    
    // Seçilen şehirlerin boşlukları temizlenip virgüllerle bağlanarak formData'ya ekleniyor.
    setFormData((prevState) => ({
      ...prevState,
      city: selectedCities
        .map(city => city.trim()) // Fazla boşlukları temizle
        .filter(city => city.length > 0) // Boş elemanları temizle
        .join(", "), // Virgüllerle ayır
    }));
  };
  

  // Dosya yükleme işlemi
  // const handleFileChange = (e) => {
  //   setFormData((prevState) => ({
  //     ...prevState,
  //     document_upload: e.target.files[0], // Sadece bir dosya kabul edilir
  //   }));
  // };

  const setCompanyName = (e) => {
    setselectedCompany(e.target.value)
    if (e.target.value !== "" && e.target.value !== null) {
      console.log("girdi")
      setFormData((prevState) => ({
        ...prevState,
        company_name: e.target.value,
      }));
    } else {
      setFormData((prevState) => ({
        ...prevState,
        company_name: company.company_name,
      }));
    }

  }

  // Form gönderimi
  const handleSubmit = async (e) => {

    if(!dataValues){
      alert("İlan oluşturabilmek için profil kısmından firma detaylarını giriniz")
      return
    }
    e.preventDefault();

    if (
      !formData.city?.trim() || 
      !formData.company_name?.trim() || 
      !formData.position_category?.trim() || 
      !formData.company_about?.trim() || 
      !formData.job_type?.trim() || 
      !formData.job_description?.trim() || 
      !formData.required_experience?.trim() || 
      !formData.required_qualifications?.trim()
    ) {
      alert("Lütfen gerekli alanları doldurunuz");
      return;
    }
    

    const data = new FormData();
    // FormData'ya her bir alanı ekle
    for (const key in formData) {
      if (formData[key]) {
        data.append(key, formData[key]);
      }
    }

    console.log(formData)
    try {
      const response = await axios.post('https://kariyer.biyomed.net/api/companies/create-post', data, { withCredentials: true }, {
        headers: {
          'Content-Type': 'multipart/form-data', // Dosya gönderirken bu header gerekli
        },
      });
      alert('İş ilanı başarıyla oluşturuldu!');
      window.location.href = '/myposts'
      console.log(response.data);
    } catch (error) {
      alert('Error creating job posting!');
      console.error(error);
    }
  };

  return ( <>{isCompany ? <div className="bm-page">
    <div className="bm-container">
      <div className="bm-page-head">
        <h1 className="bm-page-title">Yeni İlan Oluştur</h1>
        <p className="bm-page-sub">
          <span style={{ color: "#dc2626" }}>*</span> ile işaretli alanların doldurulması zorunludur.
        </p>
      </div>

      {/* Temel bilgiler */}
      <div className="bm-card">
        <div className="bm-card-head">
          <span className="bm-card-badge"><i className="fa fa-briefcase" /></span>
          <h3>İlan Bilgileri</h3>
        </div>

        <div className="bm-card-body">
          <div className="bm-form-grid">
            <div className="bm-field">
              <label className="bm-label">Firma Adı <span className="bm-req">*</span></label>
              {company.user_type === "Dernek" ? (
                <select
                  className="bm-select"
                  name="company_name"
                  value={selectedCompany}
                  onChange={(e) => { setCompanyName(e) }}
                >
                  <option disabled value="">Şirket seçiniz</option>
                  {companies.map((company, index) => (
                    <option key={index} value={company.company_name}>
                      {company.company_name}
                    </option>
                  ))}
                </select>
              ) : (
                <input
                  className="bm-input"
                  type="text"
                  name="company_name"
                  value={company.company_name}
                  placeholder="Firma Adı *"
                  disabled
                />
              )}
            </div>

            <div className="bm-field">
              <label className="bm-label">İlan Türü</label>
              <select
                className="bm-select"
                name="job_type"
                value={formData.job_type}
                onChange={handleChange}
              >
                <option disabled value="">İlan Türü seçiniz</option>
                <option value="Staj">Staj ilanı</option>
                <option value="Is">İş ilanı</option>
              </select>
            </div>

            <div className="bm-field">
              <label className="bm-label">Pozisyon Adı <span className="bm-req">*</span></label>
              <input
                className="bm-input"
                type="text"
                name="position_name"
                value={formData.position_name}
                onChange={handleChange}
                placeholder="Örn: Biyomedikal Servis Mühendisi"
                required
              />
            </div>

            <div className="bm-field">
              <label className="bm-label">Pozisyon Kategorisi <span className="bm-req">*</span></label>
              <select
                className="bm-select"
                name="position_category"
                value={formData.position_category}
                onChange={handleChange}
              >
                <option value="" disabled>Pozisyon Kategorisi Seçiniz</option>
                {positionCategories.map((category, index) => (
                  <option key={index} value={category}>
                    {category}
                  </option>
                ))}
              </select>
            </div>

            <div className="bm-field">
              <label className="bm-label">Çalışma Şekli</label>
              <select
                className="bm-select"
                name="work_style"
                value={formData.work_style}
                onChange={handleChange}
              >
                <option disabled value="Secilmedi">Çalışma Şekli seçiniz</option>
                <option value="Uzaktan">Uzaktan</option>
                <option value="Hibrid">Hibrid</option>
                <option value="Is yerinde">İş Yerinde</option>
              </select>
            </div>

            <div className="bm-field">
              <label className="bm-label">Aranan Deneyim <span className="bm-req">*</span></label>
              <select
                className="bm-select"
                name="required_experience"
                value={formData.required_experience}
                onChange={handleChange}
              >
                <option disabled value="">Aranan Deneyim (Yıl)</option>
                <option value="0-2">0-2 Yıl</option>
                <option value="2-5">2-5 Yıl</option>
                <option value="5-10">5-10 Yıl</option>
                <option value="10+">10+ Yıl</option>
              </select>
            </div>

            <div className="bm-field">
              <label className="bm-label">İl <span className="bm-req">*</span></label>
              <FormControl fullWidth size="small">
                <Select
                  multiple
                  displayEmpty
                  name="city"
                  value={formData.city.split(", ")}
                  onChange={handleCityChange}
                  renderValue={(selected) => {
                    const list = selected.filter(Boolean);
                    return list.length ? list.join(", ") : "İl Seçiniz";
                  }}
                >
                  {cities.map((city, index) => (
                    <MenuItem key={index} value={city}>
                      <Checkbox checked={formData.city.split(", ").includes(city)} />
                      <ListItemText primary={city} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>

            <div className="bm-field">
              <label className="bm-label">Pozisyon Etiketleri</label>
              <input
                className="bm-input"
                type="text"
                name="position_tags"
                value={formData.position_tags}
                onChange={handleChange}
                placeholder="Örn: satış, kalibrasyon, iso13485"
              />
            </div>

            <div className="bm-field">
              <label className="bm-label">İlan Linki</label>
              <input
                className="bm-input"
                type="text"
                name="job_link"
                value={formData.job_link}
                onChange={handleChange}
                placeholder="https://..."
              />
            </div>

            <div className="bm-field">
              <label className="bm-label">İlan Durumu <span className="bm-req">*</span></label>
              <select
                className="bm-select"
                name="job_status"
                value={formData.job_status}
                onChange={handleChange}
                required
              >
                <option disabled value="">İlan Durumu seçiniz</option>
                <option value="1">Yayımda</option>
                <option value="0">Kapalı</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      {/* Ilan metinleri */}
      <div className="bm-card">
        <div className="bm-card-head">
          <span className="bm-card-badge"><i className="fa fa-align-left" /></span>
          <h3>İlan Detayları</h3>
        </div>

        <div className="bm-card-body">
          {/* <div className="jp_adp_choose_resume">
            <p>Belge Ekle</p>
            <div className="custom-input">
              <span>
                <i className="fa fa-upload" /> &nbsp;Belge Yükle
              </span>
              <input
                type="file"
                name="document_upload"
                onChange={handleFileChange}
              />
            </div>
          </div> */}

          <div className="bm-section">
            <label className="bm-label" htmlFor="company_about">Firma Hakkında <span className="bm-req">*</span></label>
            <JoditEditor
              name="company_about"
              value={formData.company_about}
              onBlur={(value) => setFormData({ ...formData, company_about: value })}
              placeholder="Firma Hakkında"
            />
          </div>

          <div className="bm-section">
            <label className="bm-label" htmlFor="required_qualifications">Aranan Nitelikler <span className="bm-req">*</span></label>
            <JoditEditor
              value={formData.required_qualifications}
              onBlur={(value) => setFormData({ ...formData, required_qualifications: value })}
              placeholder="Aranan Nitelikler"
            />
          </div>

          <div className="bm-section">
            <label className="bm-label" htmlFor="job_description">İş Tanımı <span className="bm-req">*</span></label>
            <JoditEditor
              value={formData.job_description}
              onBlur={(value) => setFormData({ ...formData, job_description: value })}
              placeholder="İş tanımı"
            />
          </div>

          <div className="bm-section">
            <label className="bm-label" htmlFor="other_comments">Diğer Açıklamalar</label>
            <JoditEditor
              value={formData.other_comments}
              onBlur={(value) => setFormData({ ...formData, other_comments: value })}
              placeholder="Diğer Açıklamalar"
            />
          </div>
        </div>

        <div className="bm-form-footer bm-form-footer--end">
          <Button
            variant="contained"
            color="primary"
            startIcon={<AddCircleIcon />}
            onClick={handleSubmit}
            sx={{
              fontSize: "15px",
              padding: "10px 22px",
              borderRadius: "10px",
              textTransform: "none",
              fontWeight: 600,
              boxShadow: "none",
              transition: "0.2s",
              "&:hover": {
                transform: "translateY(-1px)",
                boxShadow: "0 6px 16px rgba(0,181,228,0.35)",
              },
            }}
          >
            İlan Oluştur
          </Button>
        </div>
      </div>
    </div>
  </div> : <NotFoundPage/>}</>

  );
};

export default CreatePost;
